var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('spinner-loader',{attrs:{"loading":_vm.loading}}),(!_vm.loading)?_c('azkar-category-form',{attrs:{"item":_vm.azkarCategory,"disabled":true}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }